import React from "react";

export default function CommunicationExamples() {
  const [showingMoreSMS, setShowingMoreSMS] = React.useState<boolean>(false);
  const [showingMoreEmail, setShowingMoreEmail] =
    React.useState<boolean>(false);

  const handleClickToggleShowMoreSMS = () => {
    setShowingMoreSMS(!showingMoreSMS);
  };

  const handleClickToggleShowMoreEmail = () => {
    setShowingMoreEmail(!showingMoreEmail);
  };

  return (
    <div className="flex items-start gap-8">
      <div className="basis-1/2">
        <h3 id="example_sms" className="h3 my-4">
          SMS
        </h3>
        <img
          alt="Example Keepsight SMS message, long text description is below"
          className="block my-4 mx-auto mb-4"
          src="/images/optimate_instructions/04.png"
        />
        <p>
          <button
            className="btn btn-primary block mx-auto"
            onClick={handleClickToggleShowMoreSMS}
            aria-label={
              showingMoreSMS === true
                ? "Hide text for the example SMS"
                : "Show text for the example SMS"
            }
          >
            {showingMoreSMS === true ? "Hide text" : "Show text"}
          </button>
        </p>
        {showingMoreSMS === true && (
          <>
            <h4 className="h4">Example SMS long text description</h4>
            <p>
              Important message from Diabetes Australia. Have you had a diabetes
              eye check since your last visit to Optometry South? Find out more
              at https://keepsight.com.au/3x5VIRM Unsubscribe at
              https://keepsight.com.au/3v4js1E
            </p>
          </>
        )}
      </div>
      <div className="basis-1/2">
        <h3 id="example_email" className="h3 my-4">
          Email
        </h3>
        <img
          alt="Example Keepsight email message, long text description is below"
          className="block my-4 mx-auto mb-4"
          src="/images/optimate_instructions/05.png"
        />
        <p>
          <button
            className="btn btn-primary block mx-auto"
            onClick={handleClickToggleShowMoreEmail}
            aria-label={
              showingMoreSMS === true
                ? "Hide text for the example email"
                : "Show text for the example email"
            }
          >
            {showingMoreEmail === true ? "Hide text" : "Show text"}
          </button>
        </p>
        {showingMoreEmail === true && (
          <>
            <h4 className="h4">Example Email long text description</h4>
            <p>Dear John Doe,</p>
            <p>
              At your last eye check diabetes eye care visit, your optometrist
              Optometry South recorded your diabetes eye check with Keepsight,
              the national eye check reminder program run by Diabetes Australia.
            </p>
            <p>Our records show you may now be due for a diabetes eye check.</p>
            <p>Have you had your eyes checked in the last six months?</p>
            <p>Yes / No</p>
            <p>
              To make an appointment with your eye care provider, go to
              Optometry South
            </p>
            <p>
              Keepsight reminds you when it's time to have a diabetes eye check.
            </p>
            <p>
              Regular eye checks can pick up any changes to your eyes. Early
              detection saves sight.
            </p>
            <p>
              To find our more, visit keepsight.org.au or call{" "}
              <a href={`tel:${window.SETTINGS.contact_phone_number}`}>
                {window.SETTINGS.contact_phone_number}
              </a>
            </p>
            <p>
              You can also see our privacy policy and terms and conditions. If
              you wish to unsubscribe, please call{" "}
              <a href={`tel:${window.SETTINGS.contact_phone_number}`}>
                {window.SETTINGS.contact_phone_number}
              </a>{" "}
              or click here.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
